import React, { useContext } from "react";
import { WrapPageCover, PageContent, Circle, Title, WrapCover } from './Style'
import { NextButton } from "pages/School/PerformAssessment";
import { useSelector } from "react-redux";
import { categories } from "keys";

const PageCover = React.forwardRef((props, ref) => {
    const { currentPage, handleFlipPrev, firstPage, children } = props

    const { assessment } = useSelector(state => state.assessment)

    const customUI = {
        [categories.BIBLICAL_TEXT]: {
            hideCoverImage: true
        }
    }

    const customUiItem = customUI?.[assessment?.reading_assessment_category_name]

    return (
        <WrapCover>
            <WrapPageCover {...customUiItem} $firstPage={firstPage} className="page page-cover" ref={ref} data-density="hard">
                <PageContent $firstPage={firstPage} className="page-content">
                    <Title>
                        {children}
                    </Title>
                </PageContent>
            </WrapPageCover>
        </WrapCover>
    );
});

export default PageCover